import React from 'react';
import { Outlet } from 'react-router-dom';
import { TourProvider } from '../tour/TourProvider';
import TourWelcomeModal from '../components/client/TourWelcomeModal';
import { useClientLayout } from './client/useClientLayout';
import { ClientSidebar } from './client/ClientSidebar';
import { ClientHeader } from './client/ClientHeader';

const ClientLayout = () => {
  const { sidebarOpen, setSidebarOpen, clientInfo, messageSummary, handleLogout } = useClientLayout();

  return (
    <TourProvider>
      <div className="min-h-screen bg-gray-50" data-testid="client-layout">
        {/* Guided tour welcome / what's-new prompt */}
        <TourWelcomeModal />

        {/* Mobile sidebar overlay */}
        {sidebarOpen && (
          <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={() => setSidebarOpen(false)} />
        )}

        <ClientSidebar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          clientInfo={clientInfo}
          messageSummary={messageSummary}
          onLogout={handleLogout}
        />

        {/* Main content area */}
        <div className="lg:pl-64">
          <ClientHeader onOpenSidebar={() => setSidebarOpen(true)} />

          {/* Page content */}
          <main className="p-4 lg:p-6" data-testid="client-main-content">
            <Outlet />
          </main>
        </div>
      </div>
    </TourProvider>
  );
};

export default ClientLayout;
